import { type ColumnElementType, type Table } from '../../types';
import { type ExtendedLayouts } from '../layouts';

const PRICE_ROWS = 4;

interface GetMaxRowsProps {
  element: ColumnElementType;
  elements: ColumnElementType[];
  layout: ExtendedLayouts;
  table?: Table;
}

const calculateFeaturesRows = (table: Table, layout: ExtendedLayouts) => {
  const multiplier = layout === 'comparisonTableMobile' ? 2 : 1;

  return (
    multiplier *
    table.columns.reduce(
      (max, { features }) => Math.max(max, features.length),
      1
    )
  );
};

export const getMaxRows = ({
  element,
  elements,
  layout,
  table
}: GetMaxRowsProps) => {
  if (!table) {
    return 0;
  }

  const elementExists = elements.includes(element);

  const rowCounts = {
    button: elementExists ? 1 : 0,
    title: elementExists ? 1 : 0,
    picture: elementExists ? 1 : 0,
    features: elementExists ? calculateFeaturesRows(table, layout) : 0,
    price: elementExists ? PRICE_ROWS : 0
  };

  return rowCounts[element];
};
